import type {ReactNode} from 'react'
import type {LucideIcon} from 'lucide-react'
import {cn} from '@/lib/utils'

type IconTextSize = 'xs' | 'sm' | 'md'

interface IconTextProps {
    icon: LucideIcon
    children: ReactNode
    size?: IconTextSize
    className?: string
    iconClassName?: string
}

const ICON_SIZE_CLASS: Record<IconTextSize, string> = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
}
const GAP_CLASS: Record<IconTextSize, string> = {
    xs: 'gap-1',
    sm: 'gap-1.5',
    md: 'gap-1.5',
}

export function IconText({icon: Icon, children, size = 'sm', className, iconClassName}: IconTextProps) {
    return (
        <span className={cn('flex items-center', GAP_CLASS[size], className)}>
            <Icon className={cn(ICON_SIZE_CLASS[size], iconClassName)}/>
            {children}
        </span>
    )
}
